module.exports = __webpack_public_path__ + "static/media/static-glitch.e171b118.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-glitch.gif
// module id = 359
// module chunks = 0